export enum OverviewDashboardInteractionTime {
  LessThan20 = '<=1200', // 20 min
  From21To40 = '1201-2400', // 20-40 min
  From41To55 = '2401-3300', // 40-55 min,
}
